<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-button type="primary" @click="show_apply"> 新增回款 </a-button>
			<a-button type="primary"> 数据导出 </a-button>
		</div>
		<div class="content_main_top">
			<a-input allowClear class="a_input_self margin_self" placeholder="审批编号" v-model="query.payBackCode" @keyup.enter.native="querylis"/>
			<a-input allowClear class="a_input_self margin_self" placeholder="客户名称" v-model="query.customerName" @keyup.enter.native="querylis"/>
			<a-select allowClear class="a_input_self margin_self" v-model="query.receiveType" placeholder="收款类型" @keyup.enter.native="querylis">
				<a-select-option :value="index" v-for="(item, index) in receiveTypes" :key="index">
					{{ item }}
				</a-select-option>
			</a-select>
			<a-button type="primary" @click="querylis"> 查询 </a-button>
			<a-button type="primary" ghost @click="reset"> 重置 </a-button>
		</div>
		<div class="content_main_center" id="content_main_center_scroll">
			<a-table :data-source="lis" bordered :loading="loading" :pagination="pagination" @change="handleTableChange" :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}</template>
				</a-table-column>
				<a-table-column key="payBackCode" title="审批编号" data-index="payBackCode" />
				<a-table-column key="createByName" title="提交人" data-index="createByName" />
				<a-table-column key="receiveType" title="收款类型" data-index="receiveType">
					<template scope="text">
						{{ receiveTypes[text] }}
					</template>
				</a-table-column>
				<a-table-column key="customerName" title="客户名称" data-index="customerName" />
				<a-table-column key="payee" title="收款人" data-index="payee" />
				<a-table-column key="contractAmount" title="合同金额" data-index="contractAmount" />
				<a-table-column key="contractDate" title="合同日期" data-index="contractDate" />
				<a-table-column key="expiryDate" title="到期日期" data-index="expiryDate" />
				<a-table-column key="payBackDate" title="回款日期" data-index="payBackDate" />
				<a-table-column key="amount" title="回款金额" data-index="amount" />
				<a-table-column title="详情" width="80px">
					<template scope="text,record">
						<a @click="show_details(record)">详情</a>
					</template>
				</a-table-column>
			</a-table>
		</div>
		<a-modal title="新增回款" :visible="is_show_apply" @cancel="is_show_apply = false" width="70%" :maskClosable = "false">
			<template slot="footer">
				<a-button key="back" @click="is_show_apply = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="handleOk"> 提交 </a-button>
			</template>
			<a-form-model :model="form" :label-col="labelCol" ref="ruleForm" :rules="rules" :wrapper-col="wrapperCol">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="收款类型" prop="receiveType">
							<a-select style="width: 100%" v-model="form.receiveType" placeholder="请选择">
								<a-select-option :value="index" v-for="(item, index) in receiveTypes" allowClear :key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="客户名称" prop="customerName">
							<a-input v-model="form.customerName" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="收款人" prop="payee">
							<a-input v-model="form.payee" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="收款账户" prop="account">
							<a-input v-model="form.account" allowClear placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row style="margin-bottom: 15px"><span class="form_title">合同信息</span></a-row>
				<a-row>
					<a-input allowClear class="a_input_self margin_self" placeholder="客户名称" v-model="contractQuery.customerName" />
					<a-input allowClear class="a_input_self margin_self" placeholder="项目编号" v-model="contractQuery.contractCode" />
					<a-input allowClear class="a_input_self margin_self" placeholder="跟进人" v-model="contractQuery.followerName" />
					<a-button type="primary" @click="search"> 查询 </a-button>
					<a-button type="primary" ghost @click="result"> 重置 </a-button>
				</a-row>
				<a-row style="margin: 25px 0">
					<a-table :data-source="contracts" bordered :scroll="{ y: 400, scrollToFirstRowOnChange: true }" rowKey="id"
					 :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChangeTab, type: 'radio' }" @change="handleTableChangeContract">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (paginationContract.current - 1) * paginationContract.pageSize + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="customerName" title="客户名称" data-index="customerName" />
						<a-table-column key="contractCode" title="项目编号" data-index="contractCode" />
						<a-table-column key="projectName" title="合同名称" data-index="projectName" />
						<a-table-column key="contractAmount" title="合同金额" data-index="contractAmount" />
						<a-table-column key="expiryDate" title="到期日期" data-index="expiryDate" />
						<a-table-column key="followerName" title="跟进人" data-index="followerName" />
						<a-table-column key="followerDeptName" title="跟进人部门" data-index="followerDeptName" />
					</a-table>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="合同编号">
							<a-input v-model="form.projectCode" disabled placeholder="请选择合同"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="合同名称">
							<a-input v-model="form.projectName" disabled placeholder="请选择合同"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="合同金额">
							<a-input v-model="form.contractAmount" disabled placeholder="请选择合同"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="合同日期">
							<a-input v-model="form.contractDate" disabled placeholder="请选择合同"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="到期日期">
							<a-input v-model="form.expiryDate" disabled placeholder="请选择合同"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row style="margin-bottom: 15px"><span class="form_title">收款信息</span></a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="回款日期" prop="payBackDate">
							<a-date-picker valueFormat="YYYY-MM-DD" v-model="form.payBackDate" placeholder="请选择" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="回款金额" prop="amount">
							<a-input v-model="form.amount" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="剩余回款金额" prop="remainingMoney">
							<a-input v-model="form.remainingMoney" disabled placeholder="请选择合同"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="图片" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<a-modal title="回款详情" :visible="is_show_details" @cancel="is_show_details = false" width="70%">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="is_show_details=false"> 确定 </a-button>
			</template>
			<a-form-model :model="details" v-if="details!=null" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="收款类型" prop="receiveType">{{receiveTypes[details.receiveType]}}</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="客户名称" prop="customerName">{{details.customerName}}</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="收款人" prop="payee">{{details.payee}}</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="收款账户" prop="payee">{{details.account}}</a-form-model-item>
					</a-col>
				</a-row>
				<a-row style="margin-bottom: 15px"><span class="form_title">合同信息</span></a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="合同编号">{{details.contractCode}}</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="合同名称">{{details.contractName}}</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="合同金额">{{details.contractAmount}}</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="合同日期" prop="payee">{{details.contractDate}}</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="到期日期" prop="payee">{{details.expiryDate}}</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="剩余回款金额" prop="payee">{{details.remainingMoney}}</a-form-model-item>
					</a-col>
				</a-row>
				<a-row style="margin-bottom: 15px"><span class="form_title">收款信息</span></a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="回款日期" prop="payee">{{details.payBackDate}}</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="回款金额" prop="payee">{{details.amount}}</a-form-model-item>
					</a-col>

				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="报销凭证" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<div class="view_path_img" v-for="(item, index) in details.img" :key="index" style="display: flex; justify-content: space-between">
								<div class="view_path_img_margin"></div>
								<div class="view_path_img_center">
									<img :src="item.preUrl" @click="show_img(index, details.img)" />
								</div>
							</div>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<div class="view_path" @click="previewFile(item)" v-for="(item, index) in details.file" :key="index">
								{{ item.name }}
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<!-- details -->
		<preview ref="preview" />
	</div>
</template>
<script>
	import uploadFileCode from '@/components/module/uploadFileCode.vue'
	import uploadImgJava from '@/components/module/uploadImgJava.vue'
	import {
		pay_back_save,
		pay_back_list,
		pay_back_code,
		contract_apply_list
	} from '@/api/financial'
	import preview from '@/components/module/prview'
	export default {
		components: {
			uploadFileCode,
			uploadImgJava,
			preview
		},
		data() {
			return {
				selectedRowKeysTab: [],
				selectedRowKeysTabItems: [],
				uploadData: {
					code: '',
					type: 'pay-back-file',
					// types: ['application/pdf'],
				},
				uploadDataImg: {
					code: '',
					type: 'pay-back-img',
				},
				isRouterAlive: true,
				scroll_y: 150,
				loading: false,
				lis: [],
				contractQuery: {
					followerName: '', //跟进人查询
					contractCode: '',
					createByName: '',
				},
				paginationContract: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				contracts: [],
				query: {
					payBackCode: '', //   回款管理申请编号
					payee: '', //  客户名称
					receiveType: undefined, // 收款类型
				},
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				labelCol: {
					span: 9,
				},
				wrapperCol: {
					span: 15,
				},
				is_show_apply: false,
				receiveTypes: {
					1: '合同回款',
					2: '合同预付款'
				},
				rules: {
					receiveType: [{
						required: true,
						message: '请选择收款类型',
						trigger: 'blur'
					}],
					customerName: [{
						required: true,
						message: '请输入客户名称',
						trigger: 'blur'
					}],
					payee: [{
						required: true,
						message: '请输入收款人',
						trigger: 'blur'
					}],
					account: [{
						required: true,
						message: '请输入收款账户',
						trigger: 'blur'
					}],
					payBackDate: [{
						required: true,
						message: '请选择回款日期',
						trigger: 'blur'
					}],
					amount: [{
						required: true,
						message: '请输入回款金额',
						trigger: 'blur'
					}],
				},
				form: {
					payBackCode: '', //回款编号
					receiveType: undefined, //收款类型;1合同回款、2合同预付款）
					customerName: '', //	客户名称
					payee: '', //	收款人
					account: '', //收款账户
					contractApplyId: '', //合同审批id
					payBackDate: '', //	回款日期
					amount: '', //	回款金额;元)
					remainingMoney: '', //	剩余回款金额
					userId: '', //提交人

					projectCode: '', //
					projectName: '', //
					contractAmount: '', //
					contractDate: '', //
					expiryDate: '', //
				},
				is_show_details: false,
				details: null,
			}
		},
		mounted() {
			this.get_lis_contract()
			this.get_lis()
			this.$nextTick(() => {
				var max_h = $('#content_main_center').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 50
				}, 1000)
			})
		},
		methods: {
			show_img(idx, imgs) {
				var row = {
					index: idx,
					imgs: imgs,
				}
				this.$refs.preview.show(row)
			},
			//预览文件
			previewFile(file) {
				console.log(file)
				window.open(file.preUrl)
			},
			result() {
				this.contractQuery = {}
			},
			search() {
				this.get_lis_contract()
			},
			//获取合同列表
			get_lis_contract() {
				contract_apply_list({
					pageSize: this.paginationContract.pageSize,
					pageNum: this.paginationContract.current,
					followerName: this.contractQuery.followerName,
					contractCode: this.contractQuery.contractCode,
					customerName: this.contractQuery.customerName,
					isPayBack: 1,
				}).then((res) => {
					const paginationContract = { ...this.paginationContract
					}
					paginationContract.total = res.total
					this.paginationContract = paginationContract
					this.contracts = res.rows
				})
			},
			//搜索合同
			serchQueryContract() {
				this.paginationContract.current = 1
				this.get_lis_contract()
			},
			//切换合同分页
			handleTableChangeContract(pagination, filters, sorter) {
				this.paginationContract.current = paginationContract.current
				this.get_lis_contract()
			},
			//点击合同审批
			show_apply() {
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				this.search()
				this.selectedRowKeysTab=[]
				this.form = {
						payBackCode: '', //回款编号
						receiveType: undefined, //收款类型;1合同回款、2合同预付款）
						customerName: '', //	客户名称
						payee: '', //	收款人
						account: '', //收款账户
						contractApplyId: '', //合同审批id
						payBackDate: '', //	回款日期
						amount: '', //	回款金额;元)
						remainingMoney: '', //	剩余回款金额
						userId: '', //提交人

						projectCode: '', //
						projectName: '', //
						contractAmount: '', //
						contractDate: '', //
						expiryDate: '', //
					},
					pay_back_code().then((res) => {
						this.uploadData.code = res.data
						this.uploadDataImg.code = res.data
						this.form.payBackCode = res.data
						this.is_show_apply = true
					})
			},
			//选择第一个表格
			onSelectChangeTab(selectedRowKeys, selectedRows) {
				console.log(selectedRows)
				this.selectedRowKeysTabItems = JSON.parse(JSON.stringify(selectedRows))
				this.selectedRowKeysTab = selectedRowKeys
				this.form.projectCode = selectedRows[0].projectCode
				this.form.projectName = selectedRows[0].projectName
				this.form.contractAmount = selectedRows[0].contractAmount
				this.form.contractDate = selectedRows[0].contractDate
				this.form.expiryDate = selectedRows[0].expiryDate
				this.form.contractApplyId = selectedRowKeys[0]
				this.form.remainingMoney = selectedRows[0].remainingMoney
				this.form.userId = selectedRows[0].createBy
			},
			//提交
			handleOk() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						pay_back_save(this.form).then((res) => {
							if (res.code != 200) {
								this.$message.error(res.msg)
								return
							}
							this.$message.success('提交成功')
							this.is_show_apply = false
							this.get_lis()
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},
			//获取列表
			get_lis() {
				pay_back_list({
					pageSize: this.pagination.pageSize,
					pageNum: this.pagination.current,
					payBackCode: this.query.payBackCode, //   回款管理申请编号
					payee: this.query.payee, // 客户名称
					receiveType: this.query.receiveType, //收款类型
					sortField: 'id',
					sortOrder: 'desc',
				}).then((res) => {
					const pagination = { ...this.pagination
					}
					pagination.total = res.total
					this.pagination = pagination
					this.lis = res.rows
				})
			},
			//重置
			reset() {
				this.query = {
					payBackCode: '', //   回款管理申请编号
					payee: '', //  客户名称
					receiveType: undefined, // 收款类型
				}
			},
			//搜索
			querylis() {
				this.pagination.current = 1
				this.get_lis()
			},
			//切换合同分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.get_lis()
			},
			//详情
			show_details(row) {
				this.details = row;
				this.is_show_details = true;
				console.log(row)
			}
		},
	}
</script>
<style>
	.form_title {
		margin-left: 15px;
		margin-bottom: 15px;
		font-size: 17px;
		color: #999;
	}
	.view_path {
		width: 100%;
		float: left;
		cursor: pointer;
		color: #00A2FD;
	}
	.ant-upload-list-item-name{
		color: #00A2FD;
	}
</style>
